<div class="dialog-wrappers">
  <div class="content-box">
  <div class="display-flex padding-dialog dialog-header">
  <div class="float-left">
    <div class="dialog-header-title">        
      <h1>Profile</h1>
    </div>      
  </div>
  <div class="float-right">
    <span class="close-dialog" (click)="closeDialog()"><img src="../../../assets/icons/icon-close.png" alt="Close" width="16" /></span>
     
    </div>
  </div>

  <!-- <h2>
    <div class="left-titl-buton ">
      <div class="title">
        Profile
      </div>
      <button class="cancel-button" (click)="closeDialog()">&times;</button>
    </div>
  </h2> -->
  <mat-dialog-content>
  <div class="padding-dialog">
    <div class="data">
      <div class="Info">
        <div class="second">
          <div class="header-container">
            <div class="profile-image">
              <img [src]="profileImageUrl" class="user-img-lu profile-img" alt="Profile Image"
                *ngIf="isExistProfileImage" />
              <img class="user-img-lu profile-img" src="../../../assets/images/profile_image_default.png" alt=""
                *ngIf="!isExistProfileImage">
            </div>
            <div class="rest-header-content">
              <p *ngIf="userProfile?.first_name"><span>Name</span> : {{userProfile?.first_name}} {{userProfile?.last_name}}</p>
              <p *ngIf="userProfile?.email"><span>Email</span> : {{userProfile?.email}}</p>
              <p *ngIf="userProfile?.wwid"><span>WWID</span> : {{userProfile?.wwid}}</p>
            </div>
          </div>
          @if(userProfile?.product){
            <p class="txt-headings">Default Platform Group</p>
            <app-product-platform></app-product-platform>
          }
        </div>
      </div>
    </div>
  </div>
  </mat-dialog-content>
  </div>
</div>